import { ReadonlyURLSearchParams } from "next/navigation";
import { APP_ENVIRONMENT } from "@/constants";

type GetSierraInstanceParams = {
  searchParams: ReadonlyURLSearchParams | null;
};

const isProd = APP_ENVIRONMENT === "prod";

export const getSierraInstance = ({
  searchParams,
}: GetSierraInstanceParams): string => {
  const sierraInstance = isProd
    ? "fExxgdUBmA_XivcBmA_XizPvI6pWqIx8oPgqSmuZaOo"
    : "TDp2Fo8BmA_XivcBmIkLrMjvI6pWqIx8oPgq9DhwmO4";

  const domain = searchParams?.has("sierra-staging")
    ? "https://eu.staging.sierra.chat"
    : "https://eu.sierra.chat";

  return `${domain}/agent/${sierraInstance}/embed`;
};
